import { render, staticRenderFns } from "./TeachingSupportResourcesComponent.vue?vue&type=template&id=3c27f518&scoped=true"
import script from "./TeachingSupportResourcesComponent.vue?vue&type=script&lang=js"
export * from "./TeachingSupportResourcesComponent.vue?vue&type=script&lang=js"
import style0 from "./TeachingSupportResourcesComponent.vue?vue&type=style&index=0&id=3c27f518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27f518",
  null
  
)

export default component.exports